import { useLocation } from "react-router-dom";
import { menuList } from "./navigation";

export const useCurrentPath = () => {
  const location = useLocation();
  const currentPathname = location.pathname;
  const currMenuItem = menuList.filter(({ path }) => currentPathname.includes(path))
  return currMenuItem[0] ? currMenuItem[0].path : "";
};
